// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeyWordRenderer__link-b47cef {
  font-weight: bold;
  color: #6266c2;
  cursor: pointer;
  text-decoration: inherit;
}

.KeyWordRenderer__container-f4dcdf {
  width: calc(100% - var(--sidebar-width));
  height: 100%;
  align-self: center;
  max-width: 400px;
  max-height: 400px;
  margin-inline-start: var(--sidebar-width);
}

.KeyWordRenderer__overlay-e0989d {
  background: none;
  cursor: default;
}

.KeyWordRenderer__popup-ca4e04 {
  flex: 1;
  width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-sizing: content-box;
  box-shadow: none;
  border-radius: 0;
  background: none;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/components/TextRenderer/renderTree/KeyWordRenderer/KeyWordRenderer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;AACF;;AAEA;EACE,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,OAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AACF","sourcesContent":[".link {\n  font-weight: bold;\n  color: #6266c2;\n  cursor: pointer;\n  text-decoration: inherit;\n}\n\n.container {\n  width: calc(100% - var(--sidebar-width));\n  height: 100%;\n  align-self: center;\n  max-width: 400px;\n  max-height: 400px;\n  margin-inline-start: var(--sidebar-width);\n}\n\n.overlay {\n  background: none;\n  cursor: default;\n}\n\n.popup {\n  flex: 1;\n  width: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  box-sizing: content-box;\n  box-shadow: none;\n  border-radius: 0;\n  background: none;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `KeyWordRenderer__link-b47cef`,
	"container": `KeyWordRenderer__container-f4dcdf`,
	"overlay": `KeyWordRenderer__overlay-e0989d`,
	"popup": `KeyWordRenderer__popup-ca4e04`
};
module.exports = ___CSS_LOADER_EXPORT___;
